module.exports = __webpack_public_path__ + "img/art1-img1.d99eff73.jpeg";